import { useAccountCompanyId } from 'application/hooks';
import { SubscriptionStatus, useSubscriptionCost, useUserBillingInfo } from '@entities/billing';

const useSubscriptionCostPresenter = () => {
  const { watchBillingInfo } = useUserBillingInfo();

  const [
    {
      resumeCost: resumeSubscriptionCostRequest,
      extendCost: extendSubscriptionCostRequest,
      subscriptionCostByPricePlanPeriod: getSubscriptionCostByPricePlanPeriod,
    },
    subscriptionCostResult,
  ] = useSubscriptionCost();

  const licenseCostLoading = subscriptionCostResult.loading;

  const companyId = useAccountCompanyId();

  const billingInfo = watchBillingInfo(companyId);

  const subscriptionCostByPricePlanPeriod = subscriptionCostResult.data.subscriptionCostByPricePlanPeriod || 0;

  const resumeSubscriptionCost = async (count: number) => {
    const costResult = await resumeSubscriptionCostRequest(companyId, count);

    const resumeCost = costResult?.costWithDiscount || costResult?.cost || undefined;

    return billingInfo.status !== SubscriptionStatus.TrialSubscription ? resumeCost || 0 : 0;
  };

  const extendSubscriptionCost = async (count: number) => {
    const costResult = await extendSubscriptionCostRequest(companyId, count);

    return costResult?.cost || 0;
  };

  const getSubscriptionCost = async (licensesIds: string[]) => {
    const ids = licensesIds.filter((id) => billingInfo.unpaidLicenses?.find((license) => license.id === id));

    const cost = billingInfo.hasInactiveLicenses
      ? await resumeSubscriptionCost(ids.length)
      : await extendSubscriptionCost(ids.length);

    return cost;
  };

  return {
    subscriptionCostByPricePlanPeriod,
    licenseCostLoading,
    extendSubscriptionCost,
    resumeSubscriptionCost,
    getSubscriptionCost,
    getSubscriptionCostByPricePlanPeriod,
  };
};

export default useSubscriptionCostPresenter;
